<template>
  <div :id="worldname" class="sidebar">
        <h1>{{ worldname }}</h1>
        <h1>{{ message }}</h1>
      <h1>{{achievements}},{{missions}}</h1>
<div :class="worldname" id="nav">
      <div v-on:click="sidebarclick"  name="Explore" id="Explore" :class="navActive['Explore'] ? 'activeDepressed' : ''">
        Explore
        <span  v-on:click="sidebarclick"  name="Explore" v-if="selectedSection('Explore')">
          <b-icon  v-on:click="sidebarclick"  name="Explore" icon="check2-circle" aria-hidden="true" variant="success"></b-icon></span>
          <span  v-on:click="sidebarclick"  name="Explore" v-else>
            <b-icon v-on:click="sidebarclick"  name="Explore" icon="x-circle" aria-hidden="true" variant="danger"></b-icon>
        </span>
      </div>
      <div v-on:click="sidebarclick"  name="Careers" id="Careers" :class="navActive['Careers'] ? 'activeDepressed' : ''">
        Careers
        <b-icon v-on:click="sidebarclick" name="Careers" v-if="selectedSection('Careers')" icon="check2-circle" aria-hidden="true" variant="success"></b-icon>
        <b-icon v-on:click="sidebarclick" name="Careers" v-else icon="x-circle" aria-hidden="true" variant="danger"></b-icon>
      </div>
      <div v-on:click="sidebarclick" name="Employers" id="Employers" :class="navActive['Employers'] ? 'activeDepressed' : ''">
        Employers
        <span v-on:click="sidebarclick" name="Employers" v-if="selectedSection('Employers')">
          <b-icon v-on:click="sidebarclick" name="Employers" icon="check2-circle" aria-hidden="true" variant="success"></b-icon></span>
          <span v-on:click="sidebarclick" name="Employers" v-else>
            <b-icon v-on:click="sidebarclick" name="Employers" icon="x-circle" aria-hidden="true" variant="danger"></b-icon></span>
      </div>
      <div v-on:click="sidebarclick" name="Education" id="Education" :class="navActive['Education'] ? 'activeDepressed' : ''">
        Education
        <span v-on:click="sidebarclick" name="Education" v-if="selectedSection('Education')">
          <b-icon v-on:click="sidebarclick" name="Education" icon="check2-circle" aria-hidden="true" variant="success"></b-icon></span><span v-else>
            <b-icon v-on:click="sidebarclick" name="Education" icon="x-circle" aria-hidden="true" variant="danger"></b-icon> 
            </span>
      </div>
      <div  v-on:click="sidebarclick" name="PageSpecificAssessmentForm" id="PageSpecificAssessmentForm" :class="navActive['PageSpecificAssessmentForm'] ? 'activeDepressed' : ''">
        <span  v-on:click="sidebarclick" name="PageSpecificAssessmentForm"  v-if="selectedAnythingAndPendingForm()">Home</span>
        <span  v-else>
          <router-link to="/worlds">Home</router-link>
        </span>
      </div>
    </div>
   
    <div :id="region" :class="isActive ? 'show-box' : 'hid-box'">
      <svg id="backTablet" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1903.48 898.74"><defs><linearGradient id="linear-gradient" x1="3.86" y1="452.7" x2="1903.92" y2="452.7" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#b2b2b2"/><stop offset="0.63" stop-color="#ddd"/><stop offset="1" stop-color="#f1f1f1"/></linearGradient><clipPath id="clip-path" transform="translate(-3.36 -0.63)"><path d="M1882.2,259.15V72.4a15.27,15.27,0,0,0-4.46-10.78L1823,6.89a15.26,15.26,0,0,0-10.77-4.46H1273a15.24,15.24,0,0,0-10.77,4.46l-2.56,2.56a15.2,15.2,0,0,1-10.77,4.46H165a15.21,15.21,0,0,0-10.77,4.47l-19,19a15.24,15.24,0,0,1-10.77,4.46H73.12a15.24,15.24,0,0,0-10.77,4.46L39.29,69.38a15.25,15.25,0,0,0-4.47,10.78v52.65H27L10.85,149a15.25,15.25,0,0,0-4.47,10.78v101a15.23,15.23,0,0,0,4.47,10.77l16.33,16.34h7.64v32.8a15.25,15.25,0,0,0,4.47,10.78l.23.23A15.25,15.25,0,0,1,44,342.41V475.89a15.25,15.25,0,0,1-4.47,10.78h0a15.22,15.22,0,0,0-4.46,10.77v253a15.21,15.21,0,0,1-4.47,10.77L8.33,783.45a15.24,15.24,0,0,0-4.47,10.78V829.9a15.24,15.24,0,0,0,4.47,10.78l45.44,45.44a15.24,15.24,0,0,0,10.78,4.47H342.47a15.23,15.23,0,0,0,10.77-4.47l4.6-4.59a15.2,15.2,0,0,1,10.77-4.46H1670.33a15.24,15.24,0,0,1,10.78,4.46l9.77,9.78a15.29,15.29,0,0,0,10.78,4.46h131.39a15.29,15.29,0,0,0,10.78-4.46l55.63-55.63a15.29,15.29,0,0,0,4.46-10.78V293.5a15.29,15.29,0,0,0-4.46-10.78l-12.8-12.79A15.29,15.29,0,0,1,1882.2,259.15ZM1725.66,781.53h0a64.36,64.36,0,0,1-45.51,18.85H219.29a64.36,64.36,0,0,1-45.51-18.85h0A64.4,64.4,0,0,1,154.93,736V203.46A64.36,64.36,0,0,1,173.78,158h0a64.36,64.36,0,0,1,45.51-18.85H1680.15A64.36,64.36,0,0,1,1725.66,158h0a64.37,64.37,0,0,1,18.86,45.51V736A64.41,64.41,0,0,1,1725.66,781.53Z" style="fill:none"/></clipPath><radialGradient id="radial-gradient" cx="953.89" cy="449.1" r="742.32" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#f1f1f1"/><stop offset="0.6" stop-color="#eee"/><stop offset="0.97" stop-color="#e6e6e6"/><stop offset="1" stop-color="#e5e5e5"/></radialGradient><radialGradient id="radial-gradient-2" cx="953.89" cy="449.1" r="742.79" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#f1f1f1"/><stop offset="1" stop-color="#e5e5e5"/></radialGradient></defs><path d="M1882.2,262.75V76a15.27,15.27,0,0,0-4.46-10.78L1823,10.49A15.26,15.26,0,0,0,1812.24,6H1273a15.24,15.24,0,0,0-10.77,4.46l-2.56,2.56a15.2,15.2,0,0,1-10.77,4.46H165A15.21,15.21,0,0,0,154.27,22l-19,19a15.24,15.24,0,0,1-10.77,4.46H73.12a15.24,15.24,0,0,0-10.77,4.46L39.29,73a15.25,15.25,0,0,0-4.47,10.78v52.65H27L10.85,152.56a15.25,15.25,0,0,0-4.47,10.78v101a15.23,15.23,0,0,0,4.47,10.77l16.33,16.34h7.64v32.8A15.25,15.25,0,0,0,39.29,335l.23.23A15.25,15.25,0,0,1,44,346V479.49a15.25,15.25,0,0,1-4.47,10.78h0A15.22,15.22,0,0,0,35.06,501V754a15.21,15.21,0,0,1-4.47,10.77L8.33,787.05a15.24,15.24,0,0,0-4.47,10.78V833.5a15.24,15.24,0,0,0,4.47,10.78l45.44,45.44a15.24,15.24,0,0,0,10.78,4.47H342.47a15.23,15.23,0,0,0,10.77-4.47l4.6-4.59a15.2,15.2,0,0,1,10.77-4.46H1670.33a15.24,15.24,0,0,1,10.78,4.46l9.77,9.78a15.29,15.29,0,0,0,10.78,4.46h131.39a15.29,15.29,0,0,0,10.78-4.46l55.63-55.63a15.29,15.29,0,0,0,4.46-10.78V297.1a15.29,15.29,0,0,0-4.46-10.78l-12.8-12.79A15.29,15.29,0,0,1,1882.2,262.75ZM1725.66,785.13h0A64.36,64.36,0,0,1,1680.15,804H219.29a64.36,64.36,0,0,1-45.51-18.85h0a64.4,64.4,0,0,1-18.85-45.52V207.06a64.36,64.36,0,0,1,18.85-45.51h0a64.36,64.36,0,0,1,45.51-18.85H1680.15a64.36,64.36,0,0,1,45.51,18.85h0a64.37,64.37,0,0,1,18.86,45.51V739.61A64.41,64.41,0,0,1,1725.66,785.13Z" transform="translate(-3.36 -0.63)" style="fill:url(#linear-gradient)"/><rect x="97.35" y="70.06" width="1722.92" height="774.59" style="fill:#fff;opacity:0.5"/><path d="M1882.2,257.35V70.6a15.27,15.27,0,0,0-4.46-10.78L1823,5.09A15.26,15.26,0,0,0,1812.24.63H1273a15.24,15.24,0,0,0-10.77,4.46l-2.56,2.56a15.2,15.2,0,0,1-10.77,4.46H165a15.21,15.21,0,0,0-10.77,4.47l-19,19a15.24,15.24,0,0,1-10.77,4.46H73.12a15.24,15.24,0,0,0-10.77,4.46L39.29,67.58a15.25,15.25,0,0,0-4.47,10.78V131H27L10.85,147.16a15.25,15.25,0,0,0-4.47,10.78v101a15.23,15.23,0,0,0,4.47,10.77L27.18,286h7.64v32.8a15.25,15.25,0,0,0,4.47,10.78l.23.23A15.25,15.25,0,0,1,44,340.61V474.09a15.25,15.25,0,0,1-4.47,10.78h0a15.22,15.22,0,0,0-4.46,10.77v253a15.21,15.21,0,0,1-4.47,10.77L8.33,781.65a15.24,15.24,0,0,0-4.47,10.78V828.1a15.24,15.24,0,0,0,4.47,10.78l45.44,45.44a15.24,15.24,0,0,0,10.78,4.47H342.47a15.23,15.23,0,0,0,10.77-4.47l4.6-4.59a15.2,15.2,0,0,1,10.77-4.46H1670.33a15.24,15.24,0,0,1,10.78,4.46l9.77,9.78a15.29,15.29,0,0,0,10.78,4.46h131.39a15.29,15.29,0,0,0,10.78-4.46l55.63-55.63a15.29,15.29,0,0,0,4.46-10.78V291.7a15.29,15.29,0,0,0-4.46-10.78l-12.8-12.79A15.29,15.29,0,0,1,1882.2,257.35ZM1725.66,779.73h0a64.36,64.36,0,0,1-45.51,18.85H219.29a64.36,64.36,0,0,1-45.51-18.85h0a64.4,64.4,0,0,1-18.85-45.52V201.66a64.36,64.36,0,0,1,18.85-45.51h0a64.36,64.36,0,0,1,45.51-18.85H1680.15a64.36,64.36,0,0,1,45.51,18.85h0a64.37,64.37,0,0,1,18.86,45.51V734.21A64.41,64.41,0,0,1,1725.66,779.73Z" transform="translate(-3.36 -0.63)" style="fill:#e5e5e5"/><rect id="opacity-fill" x="108.31" y="93.55" width="1697.52" height="738.8" style="fill:#fff;opacity:0.98"/><g style="clip-path:url(#clip-path)"><path d="M1882.2,259.15V72.4a15.27,15.27,0,0,0-4.46-10.78L1823,6.89a15.26,15.26,0,0,0-10.77-4.46H1273a15.24,15.24,0,0,0-10.77,4.46l-2.56,2.56a15.2,15.2,0,0,1-10.77,4.46H165a15.21,15.21,0,0,0-10.77,4.47l-19,19a15.24,15.24,0,0,1-10.77,4.46H73.12a15.24,15.24,0,0,0-10.77,4.46L39.29,69.38a15.25,15.25,0,0,0-4.47,10.78v52.65H27L10.85,149a15.25,15.25,0,0,0-4.47,10.78v101a15.23,15.23,0,0,0,4.47,10.77l16.33,16.34h7.64v32.8a15.25,15.25,0,0,0,4.47,10.78l.23.23A15.25,15.25,0,0,1,44,342.41V475.89a15.25,15.25,0,0,1-4.47,10.78h0a15.22,15.22,0,0,0-4.46,10.77v253a15.21,15.21,0,0,1-4.47,10.77L8.33,783.45a15.24,15.24,0,0,0-4.47,10.78V829.9a15.24,15.24,0,0,0,4.47,10.78l45.44,45.44a15.24,15.24,0,0,0,10.78,4.47H342.47a15.23,15.23,0,0,0,10.77-4.47l4.6-4.59a15.2,15.2,0,0,1,10.77-4.46H1670.33a15.24,15.24,0,0,1,10.78,4.46l9.77,9.78a15.29,15.29,0,0,0,10.78,4.46h131.39a15.29,15.29,0,0,0,10.78-4.46l55.63-55.63a15.29,15.29,0,0,0,4.46-10.78V293.5a15.29,15.29,0,0,0-4.46-10.78l-12.8-12.79A15.29,15.29,0,0,1,1882.2,259.15ZM1725.66,781.53h0a64.36,64.36,0,0,1-45.51,18.85H219.29a64.36,64.36,0,0,1-45.51-18.85h0A64.4,64.4,0,0,1,154.93,736V203.46A64.36,64.36,0,0,1,173.78,158h0a64.36,64.36,0,0,1,45.51-18.85H1680.15A64.36,64.36,0,0,1,1725.66,158h0a64.37,64.37,0,0,1,18.86,45.51V736A64.41,64.41,0,0,1,1725.66,781.53Z" transform="translate(-3.36 -0.63)" style="stroke-miterlimit:10;fill:url(#radial-gradient);stroke:url(#radial-gradient-2)"/><path d="M101.66,478.66l-34,34a4.13,4.13,0,0,0-1.2,2.91V713a4.11,4.11,0,0,0,7,2.91l31.81-31.81a4.12,4.12,0,0,0,1.21-2.87l2.14-199.64A4.11,4.11,0,0,0,101.66,478.66Z" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M73.5,460.06,92.25,441.3a4.1,4.1,0,0,0,1.21-2.9V370a4.14,4.14,0,0,0-1.21-2.91l-19-19a4.1,4.1,0,0,0-7,2.91l.22,106.12A4.11,4.11,0,0,0,73.5,460.06Z" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M16.82,289.62h95.33a4,4,0,0,0,4-4V174.51a4,4,0,0,0-1.17-2.83L78.16,134.86a4,4,0,0,0-2.83-1.17H20.6" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M1282.82,1.61l-42.64,42.64a4,4,0,0,1-2.83,1.17H373.05a4,4,0,0,0-2.83,1.17L346.37,70.44a4,4,0,0,1-2.83,1.17H228.22a4,4,0,0,1-2.84-1.17l-25.6-25.61A4,4,0,0,0,197,43.66H130.78l-4.94-4.94" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M463.29,140.9,493,111.22a4,4,0,0,1,2.83-1.17h820.57l11.36-11.36h91.84a4,4,0,0,0,2.83-1.17l52.46-52.46a4,4,0,0,1,2.83-1.17h58.07a4,4,0,0,1,2.83,6.83l-91.75,91.75" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M1882.2,93.18l-35,35A4,4,0,0,0,1846,131V271a4,4,0,0,0,1.17,2.83l30.6,30.6a4,4,0,0,1,1.17,2.83V442a4,4,0,0,1-1.17,2.83l-96.73,96.73a4,4,0,0,0-1.17,2.83V705.64a4,4,0,0,1-1.17,2.84l-35,35" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M1903.92,477.23l-76.27,76.28a4,4,0,0,0-1.18,2.83V727a4,4,0,0,0,1.18,2.83L1904.82,807" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M1651.3,878.87l-37.78-37.79a4,4,0,0,0-2.83-1.17H427.28a4,4,0,0,0-2.83,1.17l-37.4,37.41" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M157.89,892.39l-29.14-29.14a4,4,0,0,1,0-5.66L162.32,824a4,4,0,0,1,2.83-1.17H1667a4,4,0,0,1,2.83,1.17l38.12,38.12a4,4,0,0,0,2.83,1.17h166.81" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M1904.82,508.4l-54.28,54.28a4.13,4.13,0,0,0-1.21,2.91v25.33a4.11,4.11,0,0,0,7,2.9L1906,544.18Z" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M1904.82,564.12l-54.28,54.28a4.13,4.13,0,0,0-1.21,2.91v25.33a4.11,4.11,0,0,0,7,2.9L1906,599.9Z" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M1904.82,619.84l-54.28,54.28a4.13,4.13,0,0,0-1.21,2.91v25.33a4.11,4.11,0,0,0,7,2.9L1906,655.62Z" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M1882.2,115.73l-17.54,17.54a4.12,4.12,0,0,0-1.2,2.91v90.63a4.09,4.09,0,0,0,1.2,2.9l17.54,17.54Z" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M101.66,476.86l-34,34a4.13,4.13,0,0,0-1.2,2.91v197.5a4.11,4.11,0,0,0,7,2.91l31.81-31.81a4.12,4.12,0,0,0,1.21-2.87l2.14-199.64A4.11,4.11,0,0,0,101.66,476.86Z" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#989898;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M73.5,458.26,92.25,439.5a4.1,4.1,0,0,0,1.21-2.9V368.21a4.14,4.14,0,0,0-1.21-2.91l-19-19a4.1,4.1,0,0,0-7,2.91l.22,106.12A4.11,4.11,0,0,0,73.5,458.26Z" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#989898;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M16.82,287.82h95.33a4,4,0,0,0,4-4V172.71a4,4,0,0,0-1.17-2.83L78.16,133.06a4,4,0,0,0-2.83-1.17H20.6" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#989898;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M1281,1.61l-40.84,40.84a4,4,0,0,1-2.83,1.17H373.05a4,4,0,0,0-2.83,1.17L346.37,68.64a4,4,0,0,1-2.83,1.17H228.22a4,4,0,0,1-2.84-1.17L199.78,43A4,4,0,0,0,197,41.86H130.78l-3.35-3.35" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#989898;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M463.29,139.1,493,109.42a4,4,0,0,1,2.83-1.17h820.57l11.36-11.36h91.84a4,4,0,0,0,2.83-1.17l52.46-52.46a4,4,0,0,1,2.83-1.17h58.07a4,4,0,0,1,2.83,6.83l-91.75,91.75" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#989898;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M1882.2,91.38l-35,35a4,4,0,0,0-1.17,2.83V269.16a4,4,0,0,0,1.17,2.83l30.6,30.6a4,4,0,0,1,1.17,2.83V440.18a4,4,0,0,1-1.17,2.83l-96.73,96.73a4,4,0,0,0-1.17,2.83V703.84a4,4,0,0,1-1.17,2.84l-35,35" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#989898;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M1903.92,475.43l-76.27,76.28a4,4,0,0,0-1.18,2.83V725.22a4,4,0,0,0,1.18,2.83l77.17,77.18" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#989898;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M1653.42,879.19l-39.9-39.91a4,4,0,0,0-2.83-1.17H427.28a4,4,0,0,0-2.83,1.17l-39.2,39.21" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#989898;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M159.51,892.2l-30.76-30.75a4,4,0,0,1,0-5.66l33.57-33.57a4,4,0,0,1,2.83-1.17H1667a4,4,0,0,1,2.83,1.17l38.12,38.12a4,4,0,0,0,2.83,1.17h166.81" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#989898;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M1904.82,506.6l-54.28,54.28a4.13,4.13,0,0,0-1.21,2.91v25.33a4.11,4.11,0,0,0,7,2.9L1906,542.38Z" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#989898;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M1904.82,562.32l-54.28,54.28a4.13,4.13,0,0,0-1.21,2.91v25.33a4.11,4.11,0,0,0,7,2.9L1906,598.1Z" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#989898;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M1904.82,618l-54.28,54.28a4.13,4.13,0,0,0-1.21,2.91v25.33a4.11,4.11,0,0,0,7,2.9L1906,653.82Z" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#989898;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M1882.2,113.93l-17.54,17.54a4.12,4.12,0,0,0-1.2,2.91V225a4.09,4.09,0,0,0,1.2,2.9l17.54,17.54Z" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#989898;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/></g><path d="M1812.24,2.93a14.64,14.64,0,0,1,10.42,4.32L1877.38,62a14.64,14.64,0,0,1,4.32,10.43V259.15a15.63,15.63,0,0,0,4.61,11.13l12.79,12.79a14.64,14.64,0,0,1,4.32,10.43V824.9a14.6,14.6,0,0,1-4.32,10.42L1843.47,891a14.6,14.6,0,0,1-10.42,4.32H1701.66a14.64,14.64,0,0,1-10.43-4.32l-9.77-9.77a15.61,15.61,0,0,0-11.13-4.61H368.61a15.63,15.63,0,0,0-11.13,4.61l-4.59,4.59a14.68,14.68,0,0,1-10.42,4.32H64.55a14.69,14.69,0,0,1-10.43-4.32L8.68,840.33A14.68,14.68,0,0,1,4.37,829.9V794.23A14.68,14.68,0,0,1,8.68,783.8L31,761.54a15.67,15.67,0,0,0,4.61-11.13v-253A14.67,14.67,0,0,1,39.87,487a15.62,15.62,0,0,0,4.62-11.13V342.41a15.6,15.6,0,0,0-4.62-11.13l-.23-.24a14.64,14.64,0,0,1-4.32-10.42V287.81a.5.5,0,0,0-.5-.5H27.39L11.2,271.13a14.66,14.66,0,0,1-4.32-10.42v-101a14.64,14.64,0,0,1,4.32-10.42l16-16h7.61a.5.5,0,0,0,.5-.5V80.16a14.64,14.64,0,0,1,4.32-10.42L62.7,46.68a14.62,14.62,0,0,1,10.42-4.32h51.35a15.65,15.65,0,0,0,11.13-4.61l19-19A14.6,14.6,0,0,1,165,14.41h1083.9a15.67,15.67,0,0,0,11.13-4.61l2.55-2.55A14.62,14.62,0,0,1,1273,2.93h539.2m-1592.95,798H1680.15A64.87,64.87,0,0,0,1745,736V203.46a64.87,64.87,0,0,0-64.87-64.86H219.29a64.87,64.87,0,0,0-64.86,64.86V736a64.87,64.87,0,0,0,64.86,64.87m1593-798.45H1273a15.24,15.24,0,0,0-10.77,4.46l-2.56,2.56a15.2,15.2,0,0,1-10.77,4.46H165a15.21,15.21,0,0,0-10.77,4.47l-19,19a15.24,15.24,0,0,1-10.77,4.46H73.12a15.24,15.24,0,0,0-10.77,4.46L39.29,69.38a15.25,15.25,0,0,0-4.47,10.78v52.65H27L10.85,149a15.25,15.25,0,0,0-4.47,10.78v101a15.23,15.23,0,0,0,4.47,10.77l16.33,16.33h7.64v32.81a15.25,15.25,0,0,0,4.47,10.78l.23.23A15.25,15.25,0,0,1,44,342.41V475.89a15.25,15.25,0,0,1-4.47,10.78,15.22,15.22,0,0,0-4.46,10.77v253a15.21,15.21,0,0,1-4.47,10.77L8.33,783.45a15.23,15.23,0,0,0-4.46,10.78V829.9a15.23,15.23,0,0,0,4.46,10.78l45.44,45.44a15.24,15.24,0,0,0,10.78,4.47H342.47a15.23,15.23,0,0,0,10.77-4.47l4.6-4.59a15.2,15.2,0,0,1,10.77-4.46H1670.33a15.24,15.24,0,0,1,10.78,4.46l9.77,9.78a15.29,15.29,0,0,0,10.78,4.46h131.39a15.29,15.29,0,0,0,10.78-4.46l55.63-55.63a15.29,15.29,0,0,0,4.46-10.78V293.5a15.29,15.29,0,0,0-4.46-10.78l-12.8-12.79a15.29,15.29,0,0,1-4.46-10.78V72.4a15.27,15.27,0,0,0-4.46-10.78L1823,6.89a15.26,15.26,0,0,0-10.77-4.46Zm-1592.95,798A64.36,64.36,0,0,1,154.93,736V203.46a64.36,64.36,0,0,1,64.36-64.36H1680.15a64.37,64.37,0,0,1,64.37,64.36V736a64.37,64.37,0,0,1-64.37,64.37Z" transform="translate(-3.36 -0.63)" style="fill:#989898"/><rect x="321.2" y="97.1" width="17.71" height="16.79" style="fill:#15a1c1"/><rect x="297.71" y="97.1" width="17.71" height="16.79" style="fill:#15a1c1"/><rect x="274.22" y="97.1" width="17.71" height="16.79" style="fill:#175e70"/><rect x="250.73" y="97.1" width="17.71" height="16.79" style="fill:#175e70"/><rect x="227.24" y="97.1" width="17.71" height="16.79" style="fill:#d81f2b"/><rect x="1837.6" y="318" width="16.79" height="17.71" style="fill:#15a1c1"/><rect x="1837.6" y="341.49" width="16.79" height="17.71" style="fill:#d81f2b"/><rect x="1837.6" y="364.98" width="16.79" height="17.71" style="fill:#d81f2b"/><rect x="1837.6" y="388.48" width="16.79" height="17.71" style="fill:#d81f2b"/><rect x="1837.6" y="411.97" width="16.79" height="17.71" style="fill:#b22025"/><circle cx="55.99" cy="174.61" r="10.49" style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px"/><circle cx="55.99" cy="172.81" r="10.49" style="fill:none;stroke:#989898;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px"/><circle cx="55.99" cy="172.81" r="10.49" style="fill:#15a1c1"/><circle cx="55.99" cy="209.56" r="10.49" style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px"/><circle cx="55.99" cy="207.76" r="10.49" style="fill:none;stroke:#989898;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px"/><circle cx="55.99" cy="207.76" r="10.49" style="fill:#d81f2b"/><circle cx="55.99" cy="244.51" r="10.49" style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px"/><circle cx="55.99" cy="242.71" r="10.49" style="fill:none;stroke:#989898;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px"/><circle cx="55.99" cy="242.71" r="10.49" style="fill:#d81f2b"/></svg>
      <div class="logo-for-tablet">
        <img src="https://eastalabamaworks.com/wp-content/uploads/east-logo-bug.png" width="100%" height="auto" alt="East AW Logo" />
      </div>
      <HandheldViews :region="region" v-bind:is="handheldView" :worldName='worldname' :class="region"></HandheldViews>
    </div>
  </div>
</template>

<script>
import PageSpecificAssessmentForm from  './handheld_components/individform'
import Careers from './handheld_components/Careers';
import Education from './handheld_components/Education';
import Employers from './handheld_components/Employers';
import Explore from './handheld_components/Explore';
import Assessment from './handheld_components/Assessment';
import blank from './handheld_components/blank';
import gamificationMixin from '../shared_methods/gamificationMixin';
import worldNameMixin from '../shared_methods/worldname_mixin';
import careersInfoMixin from '../shared_methods/careers_Info_Mixin';
import badgeSrcMixin from '../shared_methods/badgeSrcMixin'
export default {
  name: 'Sidebar',
  mixins:[gamificationMixin,worldNameMixin,careersInfoMixin,badgeSrcMixin],
  //TODOS
       
  //turn v-if span into component
  // make sidebar elements iteratable from object array
  data: function() {
    const jobPageInfo = this.selectJobPageInfo(process.env.VUE_APP_CURRENT_REGION,this.worldname)
    const badgeSrcInfo= this.selectBadgeSrc(process.env.VUE_APP_CURRENT_REGION.toLowerCase(),this.worldname)
   // console.log(jobPageInfo)
      return{
    // declare message with an empty value
    message: '',
    handheldView:"Explore",
    isActive: false,
    navActive:{'Explore':false,"Education":false,"Employers":false,"Careers":false,"PageSpecificAssessmentForm":false},
    region:process.env.VUE_APP_CURRENT_REGION.toLowerCase(),
     allVisitShown:false,
     jobCount: jobPageInfo.jobs.length,
     badgeInfo:badgeSrcInfo
    }   
  },  
  computed: {
      visited() {
     

      return this.$store.state.interaction_tracking_store[this.worldname].pagestate.visitedSidebarElementNames
     
    },
    achievements(){
 //     //console.warn("ACHIEVE")
      
      //console.log(this.$store.state.awards_store.currentSession.completedMissions)
      return this.$store.state.awards_store.currentSession.completedAchievements[this.worldname].length
    },
    missions(){      
      //console.warn("Missions")
      //console.log(this.$store.state.awards_store.currentSession.completedMissions[this.worldname].length)


      return this.$store.state.awards_store.currentSession.completedMissions[this.worldname].length
    },
    careersLearned(){      
      console.log(this.$store.state.awards_store.currentSession.completedMissions[this.worldname].length)

              
      return  this.$store.state.interaction_tracking_store[this.worldname].pagestate.careersLearned.length
       
    }
  
  },
  watch: {
          // eslint-disable-next-line no-unused-vars
     careersLearned(newCount, oldCount){
    //  console.log(`We have ${newCount} careers now, yay!`)
   //   console.log(`We have ${this.jobCount} careers total`)

 if (newCount == 1){
       var missionName= `${this.worldname}_LEARN1CAREER`
     //  console.log(missionName)

      
      const missionAwarded= this.missionAwarded(this.$store.state,this.worldname,{metaprep:"",missionName:missionName})
          if(missionAwarded){
           //   console.log("mission already awarded")
            
          }
          else{
               this.$bvToast.toast(`You Learned About a Career! You Earned +25 Points!`, {
          title: `Mission Accomplished`,
          autoHideDelay: 5000,
          appendToast: true
        })
        
        this.$store.commit('awards_store/ADD_COMP_MISSIONS',{
          world:this.worldname,
        missionName:missionName,
      
     
      
     
       });
                        this.$store.commit('awards_store/ADD_POINTS',{
       points:25
     
      
      
      });
          }
 }
      if (newCount == this.jobCount)
{
  var achieveName= `${this.worldname}_ALLCAREERS`        
      const achievementAwarded= this.achieveAwarded(this.$store.state,this.worldname,{achieveName:achieveName,achieveDate:""})
                if (achievementAwarded){
                //  console.log("already has it")
                }
                else{

    
               this.$store.commit('awards_store/ADD_COMP_ACHIEVE',{
           world:this.worldname,
        achieveName:achieveName,
      
     
      
     
       });
                      this.$store.commit('awards_store/ADD_POINTS',{
       points:25
     
      
      
      });
      this.$bvToast.toast(`You Learned About All Careers! You Earned +50 Points!`, {
          title: `Achievement Completed`,
          autoHideDelay: 5000,
          appendToast: true
        })
   //##INSERT FIREBASE INSERT

}

                }

     },


      // eslint-disable-next-line no-unused-vars
   achievements (newCount, oldCount) {
      // Our fancy notification (2).
      //console.warn("ACHIEVE2")
      var allDone= ((this.$store.state.awards_store.currentSession.completedAchievements[this.worldname].length>=2) && (this.$store.state.awards_store.currentSession.completedMissions[this.worldname].length>=5))
      if(allDone){
                                  //console.warn("ALL DONE")
     var achieveName= `${this.worldname}_ALLDONE` 

      const badgeAwarded= this.badgeAwarded(this.$store.state,{badgeSrc:this.badgeInfo,badgeName:this.badgeInfo})
                   //   console.log(badgeAwarded)
                if (badgeAwarded){
                //  console.log("already has it:"+this.badgeInfo)
                }
                else{

                              this.$store.commit('awards_store/ADD_BADGE',{
        badgeSrc:this.badgeInfo,
        badgeName:this.badgeInfo
     
      
      
      });
            
      this.$bvToast.toast(`You Explored the Entire World! You Earned +50 Points! `, {
          title: `Achievement ALERT! `,
          variant: 'info',
          autoHideDelay: 5000,
          appendToast: true
        })
           //##INSERT FIREBASE INSERT

               const h = this.$createElement
        // Increment the toast count
    
        // Create the message
        const vNodesMsg = h(
          'b-img',
          { props: { src: require(`@/assets/badges/${this.badgeInfo}-badge.png`) } 
          },
           
        )
        // Create the title
        const vNodesTitle = h(
          'div',
          { class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'] },
          [
            h('strong', { class: 'mr-2' }, 'BADGE ACQUIRED'),
            h('small', { class: 'ml-auto text-italics' }, '5 minutes ago')
          ]
        )
        // Pass the VNodes as an array for message and title
        this.$bvToast.toast([vNodesMsg], {
          title: [vNodesTitle],
          solid: true,
          autoHideDelay: 3400,
          appendToast: true,

          variant: 'info'
        })
                              this.$store.commit('awards_store/ADD_POINTS',{
       points:50
     
      
      
      });
             
               this.$store.commit('awards_store/ADD_COMP_ACHIEVE',{
           world:this.worldname,
        achieveName:achieveName,
      
     
      
     
       });
      }
    }
    },
        // eslint-disable-next-line no-unused-vars
      missions (newCount, oldCount) {
      // Our fancy notification (2).
     // console.log(`We have ${newCount} missions now, yay!`)
      var allDone= ((this.$store.state.awards_store.currentSession.completedAchievements[this.worldname].length>=2) && (this.$store.state.awards_store.currentSession.completedMissions[this.worldname].length>=5))
      if(allDone){
                  //        //console.warn("ALL DONE")
     var achieveName= `${this.worldname}_ALLDONE` 
      const badgeAwarded= this.badgeAwarded(this.$store.state,{badgeSrc:this.badgeInfo,badgeName:this.badgeInfo,})
                      
                if (badgeAwarded){
            //      console.log("already has it")
                }
                else{

      this.$bvToast.toast(`You Explored the Entire World! You Earned +50 Points! `, {
          title: `Achievement ALERT! `,
          variant: 'info',
          autoHideDelay: 5000,
          appendToast: true
        })
           //##INSERT FIREBASE INSERT

                              this.$store.commit('awards_store/ADD_POINTS',{
       points:50
     
      
      
      });
                              this.$store.commit('awards_store/ADD_BADGE',{
        badgeSrc:this.badgeInfo,
        badgeName:this.badgeInfo,
     
      
      
      });
         
               this.$store.commit('awards_store/ADD_COMP_ACHIEVE',{
           world:this.worldname,
        achieveName:achieveName,
      
     
      
     
       });
               const h = this.$createElement
        // Increment the toast count
    
        // Create the message
        const vNodesMsg = h(
          'b-img',
          { props: { src: require(`@/assets/badges/${this.badgeInfo}-badge.png`) } 
          },
           
        )
        // Create the title
        const vNodesTitle = h(
          'div',
          { class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'] },
          [
            h('strong', { class: 'mr-2' }, 'BADGE ACQUIRED'),
            h('small', { class: 'ml-auto text-italics' }, '5 minutes ago')
          ]
        )
        // Pass the VNodes as an array for message and title
        this.$bvToast.toast([vNodesMsg], {
          title: [vNodesTitle],
          solid: true,
          autoHideDelay: 3400,
          appendToast: true,

          variant: 'info'
        })
      }
    }
      },

    // eslint-disable-next-line no-unused-vars
    visited (newVisited, oldVisited) {
     // console.log(oldVisited)
      //console.warn('newVisit');
     // console.log(newVisited)

      // Our fancy notification (2).
      if(

        (newVisited.indexOf('Explore') > -1)
        &&
        (newVisited.indexOf('Careers') > -1)
        &&
        (newVisited.indexOf('Education') > -1)
        &&
        (newVisited.indexOf('Employers') > -1)


      ){
 if (this.allVisitShown ==false)
{      
      
      this.$bvToast.toast(`You get  50 points for visiting all the sections! `, {
          title: `Achievement ALERT! `,
          variant: 'info',
          autoHideDelay: 5000,
          appendToast: true
        })
           //##INSERT FIREBASE INSERT

                        this.$store.commit('awards_store/ADD_POINTS',{
       points:50
     
      
      
      });
      var achieveName= `${this.worldname}_VISITALL`        
      const achievementAwarded= this.achieveAwarded(this.$store.state,this.worldname,{achieveName:achieveName,achieveDate:""})
                if (achievementAwarded){
             //     console.log("already has it")
                }
                else{

    
               this.$store.commit('awards_store/ADD_COMP_ACHIEVE',{
           world:this.worldname,
        achieveName:achieveName,
      
     
      
     
       });
                      this.$store.commit('awards_store/ADD_POINTS',{
       points:25
     
      
      
      });

        this.allVisitShown=true;
                }

  


      }
      }
    },
  },
    methods: {

      selectedSection(id){
      // `this` points to the vm instance
         var identifier=id
         var visitedElements =this.$store.state.interaction_tracking_store[this.worldname].pagestate.clickedelements;
        var isVisitedExists= !(visitedElements[identifier] === undefined);
        var isVisited;
        isVisitedExists?  isVisited=visitedElements[identifier].visited   : isVisited=false;
       
         return isVisited; 
    },
    // eslint-disable-next-line no-unused-vars
    childComponentTriggerActive(componentName){
      if (this.isActive == true){
        this.isActive= !this.isActive;
      }
        // eslint-disable-next-line no-unused-vars
        var navs = ["Explore","Education","Careers","Employers","PageSpecificAssessmentForm"]
      //  console.log(navs[navs.indexOf(componentName) +1])
         this.handheldView= "blank"
        this.navActive['Explore']=false
        this.navActive['Education']=false
        this.navActive['Careers']=false
        this.navActive['Employers']=false
        this.navActive['PageSpecificAssessmentForm']=false
   
     
    },
   selectedAnythingAndPendingForm(){
      // `this` points to the vm instance
       //  console.log(this.worldname)
         var visitedElements =this.$store.state.interaction_tracking_store[this.worldname].pagestate.clickedelements;
 const formstate= this.$store.state.assessment_form_store[this.region][this.worldname].formstate.formCompleted;
 //console.log(formstate)
        //var isVisitedExists= !(visitedElements[identifier] === undefined);
         var elementCount= Object.keys(visitedElements).length;
        //isVisitedExists?  isVisited=visitedElements[identifier].visited   : isVisited=false;
     
       
         return ((elementCount>=1)&&(!formstate)); 
    },

    sidebarclick(event) {
      // `this` will refer to the component instance
      //console.log(event.target.getAttribute('name'))
      this.message=event.target.getAttribute('name');
      this.handheldView=event.target.getAttribute('name');
      if (this.isActive == false){
        this.isActive= !this.isActive;
      }
        
      if (this.navActive[this.handheldView] == false){
        this.navActive['Explore']=false
        this.navActive['Education']=false
        this.navActive['Careers']=false
        this.navActive['Employers']=false
        this.navActive['PageSpecificAssessmentForm']=false
        this.navActive[this.handheldView]=true;
        }
              var identifier=event.target.name
         var visitedElements =this.$store.state.interaction_tracking_store[this.worldname].pagestate.clickedelements;
        var isVisitedExists= !(visitedElements[identifier] === undefined);
        var isVisited;
        isVisitedExists?  isVisited=visitedElements[identifier].visited   : isVisited=false;
        var firstVisit=!isVisited;

        
      this.$store.commit('interaction_tracking_store/ADD_ELEMENTINTERACTION',{
        worldname:this.worldname,
        elementstate:true,
        elementid:event.target.id,
        elementname:event.target.class,
        interactiontype:"click",
        component:this.name,
        isSidebarComponent:true
      
      });
      if (firstVisit==true){ 
 
   
       if (event.target.id=="Employers" || event.target.id=="Education"){
       var missionName= `${this.worldname}_VISIT${event.target.id.toUpperCase()}`
       //console.log(missionName)

      
      const missionAwarded= this.missionAwarded(this.$store.state,this.worldname,{metaprep:"",missionName:missionName})
          if(missionAwarded){
         //     console.log("mission already awarded")
            
          }
          else{
               this.$bvToast.toast(` You visited the ${event.target.id} section ! You Earned +25 Points!`, {
          title: `Mission Accomplished`,
          autoHideDelay: 5000,
          appendToast: true
        })
           //##INSERT FIREBASE INSERT

        this.$store.commit('awards_store/ADD_COMP_MISSIONS',{
          world:this.worldname,
        missionName:missionName,
      
     
      
     
       });
                        this.$store.commit('interaction_tracking_store/ADD_POINTS',{
        worldname:this.worldname,
        points:25
     
      
      
      });
          }


      }


      }
    },


  },
  props: {
    worldname: String,
    
  },
  components: {
     Careers,
     Education,
     Employers,
     Explore,
     Assessment,
     blank,
    PageSpecificAssessmentForm,
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#nav {
    width: 55vw;
    height: 31vh;
    bottom: -11vh;
    left: 22.5vw;
  }

  a.router-link-active {
    margin-top: 0vh !important;
}

#eaw .logo-for-tablet{
  display:block !important;
}

.logo-for-tablet {
  display:none;
    /* border-radius: 45px; */
    position: absolute;
    z-index: 999;
    top: 4vh;
    left: 87vw;
    width: 8vw;
}
.logo-for-tablet img{
     border-radius: 45px;
     padding: 1vh 1vw;
     background-color: white;
     box-shadow: 6px 6px 12px #b8b9be, -6px -6px 12px #fff;
    }

#nav div {
    border-radius: 12px;
    background: #e5e5e5;
    box-shadow: 6px 6px 12px #b8b9be, -6px -6px 12px #fff;
    width: 6vw;
    height: 10vh;
    line-height: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 1vw;
    color: #de1a21 !important;
    font-size: 0.75vw;
    font-family: 'Montserrat', Helvetica, Arial, sans-serif;
    text-align: center;
    text-transform: uppercase;
    font-weight: bolder;
    margin-top: -5vh;
    cursor: pointer !important;
}

.activeDepressed {
box-shadow: inset 2px 2px 5px #B8B9BE, inset -3px -3px 7px #fff !important;
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 1){
#nav {
    width: 75vw;
    height: 31vh;
    bottom: -11vh;
    left: 12.5vw;
}
}

@media only screen and (max-width:960px){
  /*#nav{
   width: 157vw !important;
    height: 40vh !important;
    bottom: -11vh !important;
    left: -28.5vw !important;
  }*/
  #nav div{
        width: 20vw !important;
    height: 10vh !important;
    margin: 0 0vw !important;
    font-size: 2.25vw !important;
  }


}
</style>
